/**
 * Friendly, human-readable labels for known routes, used by
 * CopilotAmbientContextBridge to describe "current page" to the agent.
 */
export const ROUTE_LABELS: Record<string, string> = {
  "/": "Home",
  "/my-onething": "My OneThing",
  "/priorities": "Priorities",
  "/okrs": "OKRs",
  "/my-team": "My Team",
  "/org-chart": "Org Chart",
  "/profile": "Profile",
  "/admin": "Admin",
};

const PRIORITY_DETAIL_PREFIX = "/priorities/";

/** Exact match first, then a prefix check for the dynamic priority detail route. */
export function getPageLabel(pathname: string): string {
  const exact = ROUTE_LABELS[pathname];
  if (exact) return exact;

  if (pathname.startsWith(PRIORITY_DETAIL_PREFIX)) return "Priority detail";

  return "Unknown page";
}
